// Simple en/mr translations
const dict = {
    en: {
        app_name: "Lokdhara Microfinance",
        login: "Login",
        username: "Username",
        password: "Password",
        sign_in: "Sign In",
        admin_employee_login: "Admin / Employee Login",
        dashboard: "Dashboard",
        customers: "Customers",
        loans: "Loans",
        collections: "Collections",
        approvals: "Approvals",
        settings: "Settings",
        logout: "Logout",
        add_customer: "Add Customer",
        add_loan: "New Loan",
        new_collection: "New Collection",
        search_placeholder: "Search by name, mobile, or ID",
        active_loans: "Active Loans",
        total_collections: "Today's Collections",
        pending_approvals: "Pending Approvals",
        total_customers: "Total Customers",
        total_outstanding: "Total Outstanding",
        total_disbursed: "Total Disbursed",
        profit: "Total Interest Earned",
        recent_payments: "Recent Payments",
        view_all: "View all",
        name: "Name",
        mobile: "Mobile",
        alt_mobile: "Alternate Mobile",
        address: "Address",
        occupation: "Occupation",
        monthly_income: "Monthly Income",
        photo: "Customer Photo",
        aadhaar: "Aadhaar Card",
        pan: "PAN Card",
        kyc_other: "Other KYC Documents",
        reference: "Reference",
        relation: "Relation",
        save: "Save",
        cancel: "Cancel",
        call: "Call",
        share_whatsapp: "Share on WhatsApp",
        loan_type: "Loan Type",
        personal: "Personal",
        household: "Household",
        group: "Group",
        principal: "Principal (₹)",
        interest_rate: "Interest Rate (% per month)",
        tenure_months: "Tenure (months)",
        start_date: "Start Date",
        payment_mode_loan: "Payment Mode",
        interest_only: "Interest Only",
        interest_principal: "Interest + Principal",
        emi: "EMI",
        outstanding: "Outstanding Principal",
        passbook: "Passbook",
        amount: "Amount (₹)",
        mode: "Mode",
        notes: "Notes",
        proof: "Payment Proof",
        submit_collection: "Submit Collection",
        pending_admin_approval: "Pending Admin Approval",
        approve: "Approve",
        reject: "Reject",
        rejection_reason: "Rejection Reason",
        company_name: "Company Name",
        company_logo: "Company Logo",
        bank_qr: "Bank Payment QR",
        upi_id: "UPI ID",
        employees: "Employees",
        add_employee: "Add Employee",
        role: "Role",
        admin: "Admin",
        employee: "Employee",
        no_data: "No data yet",
        date: "Date",
        interest_paid: "Interest Paid",
        principal_paid: "Principal Deducted",
        balance_after: "Balance After",
        staff: "Staff",
        status: "Status",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        loan_history: "Loan History",
        call_log: "Call Log",
        add_call_note: "Add call note",
        save_note: "Save Note",
        all_loans: "All Loans",
        active: "Active",
        closed: "Closed",
        deducted_from_principal: "deducted from principal",
        company_branding: "Company Branding",
        next_interest_est: "Next month's interest (est.)",
        loan_summary: "Loan Summary",
        new_employee: "New Employee",
        type: "Type",
        loan: "Loan",
        pigmy: "Saving Scheme",
    },
    mr: {
        app_name: "लोकधारा मायक्रो फायनान्स",
        login: "लॉगिन",
        username: "वापरकर्तानाव",
        password: "पासवर्ड",
        sign_in: "साइन इन",
        admin_employee_login: "ॲडमिन / कर्मचारी लॉगिन",
        dashboard: "डॅशबोर्ड",
        customers: "ग्राहक",
        loans: "कर्ज",
        collections: "वसुली",
        approvals: "मान्यता",
        settings: "सेटिंग्ज",
        logout: "लॉगआउट",
        add_customer: "ग्राहक जोडा",
        add_loan: "नवीन कर्ज",
        new_collection: "नवीन वसुली",
        search_placeholder: "नाव, मोबाइल किंवा आयडी ने शोधा",
        active_loans: "चालू कर्जे",
        total_collections: "आजची वसुली",
        pending_approvals: "प्रलंबित मान्यता",
        total_customers: "एकूण ग्राहक",
        total_outstanding: "एकूण थकबाकी",
        total_disbursed: "एकूण वितरण",
        profit: "एकूण व्याज मिळकत",
        recent_payments: "अलीकडील पेमेंट",
        view_all: "सर्व पहा",
        name: "नाव",
        mobile: "मोबाइल",
        alt_mobile: "पर्यायी मोबाइल",
        address: "पत्ता",
        occupation: "व्यवसाय",
        monthly_income: "मासिक उत्पन्न",
        photo: "ग्राहक फोटो",
        aadhaar: "आधार कार्ड",
        pan: "पॅन कार्ड",
        kyc_other: "इतर केवायसी कागदपत्रे",
        reference: "संदर्भ",
        relation: "नाते",
        save: "जतन करा",
        cancel: "रद्द",
        call: "कॉल",
        share_whatsapp: "व्हॉट्सॲपवर शेअर करा",
        loan_type: "कर्ज प्रकार",
        personal: "वैयक्तिक",
        household: "गृह",
        group: "गट",
        principal: "मुद्दल (₹)",
        interest_rate: "व्याज दर (% प्रति महिना)",
        tenure_months: "मुदत (महिने)",
        start_date: "सुरुवात दिनांक",
        payment_mode_loan: "पेमेंट प्रकार",
        interest_only: "फक्त व्याज",
        interest_principal: "व्याज + मुद्दल",
        emi: "ईएमआय",
        outstanding: "थकीत मुद्दल",
        passbook: "पासबुक",
        amount: "रक्कम (₹)",
        mode: "प्रकार",
        notes: "नोंदी",
        proof: "पेमेंट पुरावा",
        submit_collection: "वसुली सबमिट करा",
        pending_admin_approval: "ॲडमिन मान्यतेच्या प्रतीक्षेत",
        approve: "मंजूर",
        reject: "नाकारा",
        rejection_reason: "नाकारण्याचे कारण",
        company_name: "कंपनीचे नाव",
        company_logo: "कंपनी लोगो",
        bank_qr: "बँक पेमेंट क्यूआर",
        upi_id: "यूपीआय आयडी",
        employees: "कर्मचारी",
        add_employee: "कर्मचारी जोडा",
        role: "भूमिका",
        admin: "ॲडमिन",
        employee: "कर्मचारी",
        no_data: "अद्याप डेटा नाही",
        date: "दिनांक",
        interest_paid: "व्याज भरले",
        principal_paid: "मुद्दल वजा",
        balance_after: "उर्वरित शिल्लक",
        staff: "कर्मचारी",
        status: "स्थिती",
        pending: "प्रलंबित",
        approved: "मंजूर",
        rejected: "नाकारले",
        loan_history: "कर्ज इतिहास",
        call_log: "कॉल नोंद",
        add_call_note: "कॉल नोंद जोडा",
        save_note: "नोंद जतन करा",
        all_loans: "सर्व कर्जे",
        active: "चालू",
        closed: "बंद",
        deducted_from_principal: "मुद्दलातून वजा",
        company_branding: "कंपनी ब्रँडिंग",
        next_interest_est: "पुढील महिन्याचे व्याज (अंदाजे)",
        loan_summary: "कर्ज सारांश",
        new_employee: "नवीन कर्मचारी",
        type: "प्रकार",
        loan: "कर्ज",
        pigmy: "बचत योजना",
    },
};

export function t(lang, key) {
    return (dict[lang] && dict[lang][key]) || dict.en[key] || key;
}

export const supportedLangs = ["en", "mr"];
